import React from "react";
import { Title, Meta, Link } from "react-head";

export default function SEO({ title, description, keywords, url, image }) {
  const siteUrl = url || "https://laprshka.ru";
  const img = image || `${siteUrl}/favicon.ico`;

  const metaKeywords = Array.isArray(keywords)
    ? keywords.join(", ")
    : keywords;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Лапшина Ирина",
    "jobTitle": "Частный юрист",
    "telephone": "+7-916-332-82-59",
    "email": "laptshka@mail.ru",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "ул. Ленина, д. 18",
      "addressLocality": "Наро-Фоминск",
      "addressRegion": "Московская область",
      "addressCountry": "RU"
    },
    "url": siteUrl
  };

  return (
    <>
      <Title>{title}</Title>
      <Meta name="description" content={description} />
      <Meta name="keywords" content={metaKeywords} />
      <Meta property="og:title" content={title} />
      <Meta property="og:description" content={description} />
      <Meta property="og:type" content="website" />
      <Meta property="og:url" content={siteUrl} />
      <Meta property="og:image" content={img} />
      <Meta name="robots" content="index, follow" />
      <Link rel="canonical" href={siteUrl} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </>
  );
}
